import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "@/App.tsx";
import "@/index.css";

// Systemvorgabe für das Farbschema übernehmen und Änderungen mitgehen.
const dunkel = window.matchMedia("(prefers-color-scheme: dark)");
const anwenden = (an: boolean) => document.documentElement.classList.toggle("dark", an);
anwenden(dunkel.matches);
dunkel.addEventListener("change", (e) => anwenden(e.matches));

const wurzel = document.getElementById("wurzel");
if (!wurzel) throw new Error("Wurzelelement fehlt");

createRoot(wurzel).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
